import React, { useEffect, useState } from 'react'
import { Form, Row, Col, Button, Spinner} from 'react-bootstrap'
import { useSelector } from 'react-redux';
import Icon from '../../controls/Icons/Icon';
import ServerError from '../../controls/ServerError';

export default function MasterdataForm({ _inputValue, afterSave,  onCancel }) {
    const state = useSelector(state => state);
    const [loading, setLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const [inputValue, setInputValue] = useState({
        Id: 0,
        Text: "",
        fkMasterDataTypeId:0
    });
    const [serverError, setServerError] = useState({});
    const handleChange = ((e) => {
        const name = e.target.name;
        let value = e.target.value;
        let maxLength = e.target.maxLength;
        if (e.target.type == "checkbox") {
            value = e.target.checked;
        }
        else {
            if (maxLength && maxLength > 0 && value.length > maxLength) {
                return;
            }
        }
        setInputValue(c => ({ ...c, [name]: value }));
    });
    useEffect(() => {
        setInputValue({ ...inputValue, ..._inputValue });
    }, []);

    const handleSubmit = ((e) => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            setValidated(true);
        }
        else {
            setLoading(true);
            fetch(state.projectdetail.API + "/masterdata/save", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(inputValue)
            }).then(response => response.json()).then((res) => {
                if (res.Succeeded) {
                    setValidated(false);
                    afterSave(res);
                }
                else {
                    window.alert(res.Message, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                }
            }).catch((err) => {
                window.alert(err);
            }).finally(() => {
                setLoading(false);
            });
        }
    })
   
    return (
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Row className="mb-3">
                <Col md={12}>
                    <Row>
                        <Form.Group>
                            <Form.Label>Description<code className='required-symbol'>*</code></Form.Label>
                            <Form.Control required as="textarea" name="Text" Row="15" style={{ height: "200px" }} value={inputValue.Text} onChange={handleChange} autoComplete="off" />
                            <Form.Control.Feedback type="invalid">Description is required</Form.Control.Feedback>
                        </Form.Group>
                    </Row>
                </Col>
               
            </Row>
            

            
            <Row className="mb-2">
                <Col>
                    <ServerError error={serverError} />
                </Col>
            </Row>
            <Row className="mb-2">
                <Col md={12} className='text-center'>
                    <Button variant="outline-primary" onClick={onCancel} disabled={loading}>
                        Cancel
                        {loading ? <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" /> : ""}
                    </Button>&nbsp;&nbsp;
                    <Button variant="primary" type="submit" disabled={loading}>
                        Submit
                        {loading ? <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" /> : ""}
                    </Button>
                </Col>
            </Row>
        </Form>

    )
}
